export default "//static.tradera.net/touchweb/static/output/images/push-selling-icon.c1641681.svg";